import AutoComplete from '@tarekraafat/autocomplete.js';
import { $, $$, addEventListenerAll } from '../helper/utils';
import { MOBILMEDIA } from '../helper/constants';

const isMobile = document.documentElement.classList.contains('is-mobile');
const showSearch = $('#header .show-search');
const searchForm = $('#header .search-form');
const searchInput = $('#header .search-form input');
const searchFormIcon = $('#header .search-form i');
const showMenuBtn = $('.show-menu');
const logo = $('#header .logo');
const backdrop = $('.backdrop');
const [searchIcon, closeIcon] = showSearch.children;
const headerActions = $$('.header-actions > *:not(.show-search)');
const focusableElements = () => $$('#header .autoComplete_result a, #header .show-search, #header .search-query');
let searchOpen = false;
let mobileTween;

const mainTl = gsap.timeline({
  paused: true,
  onComplete() {
  },
  onReverseComplete() {
    // remove transform styles from logo and reset styling
    gsap.set(logo, { clearProps: 'transform' });
    document.body.classList.remove('search-active');
  },
});

const dynamicTl = gsap.timeline({
  onComplete() {
    // focus input element if not mobile
    if (isMobile === false) {
      searchInput.focus();
    }
  },
  onReverseComplete() {
    gsap.set(searchFormIcon, { clearProps: 'all' });
  },
});

mainTl
  .set(searchForm, {
    visibility: 'inherit',
  })
  .to(backdrop, {
    duration: 0.2,
    autoAlpha: 1,
    ease: 'sine.out',
  })
  .to(showMenuBtn, {
    duration: 0.175,
    scale: 0,
    autoAlpha: 0,
    ease: 'sine.in',
  }, '<')
  .to(headerActions, {
    duration: 0.175,
    scale: 0,
    autoAlpha: 0,
    ease: 'sine.in',
  }, '<')
  .to(searchIcon, {
    duration: 0.2,
    autoAlpha: 0,
    ease: 'sine.in',
  }, '<')
  .to(closeIcon, {
    duration: 0.225,
    delay: 0.1,
    autoAlpha: 1,
    ease: 'sine.out',
  });

// create mobile search wrapper
const mobileSearch = document.createElement('aside');
mobileSearch.className = 'mobile-search-wrapper';
mobileSearch.setAttribute('aria-hidden', true);
mobileSearch.appendChild(searchForm.cloneNode(true));

// wrap icon and input
const mobileSearchFormGroup = document.createElement('div');
mobileSearchFormGroup.className = 'search-form-group';
mobileSearchFormGroup.appendChild(mobileSearch.querySelector('form > i'));
mobileSearchFormGroup.appendChild(mobileSearch.querySelector('form > input'));

const mobileSearchClose = document.createElement('button');
mobileSearchClose.type = 'button';
mobileSearchClose.className = 'close-mobile-search';
mobileSearchClose.innerHTML = '<i class="icon-close"></i>';
mobileSearchFormGroup.appendChild(mobileSearchClose);

// add wrapped elements to form element and append search wrapper do body
mobileSearch.querySelector('form').prepend(mobileSearchFormGroup);
document.body.appendChild(mobileSearch);

document.documentElement.addEventListener('keydown', (e) => {
  if (searchOpen === false) {
    return;
  }

  // always prevent default for up|down
  if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
    e.preventDefault();
  }

  const input = $('#header .search-query');

  // focus first or next result link
  if (e.key === 'ArrowDown') {
    // focus first if input is focused
    if (e.target === input) {
      const results = input.nextElementSibling;

      // check if results are there
      if (results.classList.contains('autoComplete_list') && results.childElementCount > 0) {
        results.querySelector('a').focus();
      }

      // focus next if a result is focused
    } else if (e.target.parentElement.classList.contains('autoComplete_result')) {
      e.target.parentElement?.nextElementSibling?.firstElementChild.focus();

      // focus sometimes bugs out, so we just put it back on first result or input
    } else if (input.parentElement.contains(e.target) === false) {
      const results = input.nextElementSibling;

      if (results.classList.contains('autoComplete_list') && results.childElementCount > 0) {
        results.querySelector('a').focus();
      } else {
        input.focus();
      }
    }

    // manualy set focus on input tab as autoComplete seems to preventDefault on Tab presses
  } else if (e.key === 'Tab' && e.target === input) {
    const results = input.nextElementSibling;

    // check if results are there
    if (results.classList.contains('autoComplete_list') && results.childElementCount > 0) {
      results.querySelector('a').focus();
    }

    // arrow up and focus is currently on a result item
  } else if (e.key === 'ArrowUp' && e.target.parentElement.classList.contains('autoComplete_result')) {
    // if first result, focus input
    if (e.target.parentElement === e.target.parentElement.parentElement.firstElementChild) {
      input.focus();
    } else {
      e.target.parentElement?.previousElementSibling?.firstElementChild.focus();
    }
  } else if (e.key === 'Enter' && e.target === input) {
    e.target.form.submit();
  }
});

export default function search(activeFocusTrap) {
  const searchInputs = $$('.search-query');
  for (const input of searchInputs) {
    // eslint-disable-next-line no-unused-vars
    const autocomplete = new AutoComplete({
      data: {
        src: async () => {
          const query = input.value;
          const source = await fetch(input.form.dataset.autocomplete + query);
          const data = await source.json();

          // update focusable elements
          activeFocusTrap.elements = focusableElements();

          return data;
        },
        cache: false,
      },
      resultItem: {
        content: (data, source) => {
          source.innerHTML = `<a href="${input.form.action}?${input.name}=${data.value}">${data.match}</a>`;
        },
        element: 'li',
      },
      selector: () => input,
      observer: true,
      threshold: 3,
      debounce: 300,
      maxResults: 5,
      highlight: {
        render: true,
      },
    });
  }

  if ($('.desktop-nav') !== null) {
    const mobileOpenBtn = $('.desktop-nav .open-search');
    mobileTween = gsap.fromTo(mobileSearch, {
      yPercent: 100,
    }, {
      duration: 0.275,
      paused: true,
      autoAlpha: 1,
      yPercent: 0,
      ease: 'sine.out',
    });

    mobileOpenBtn.addEventListener('click', () => {
      mobileTween.play();
    }, { passive: true });

    mobileSearchClose.addEventListener('click', () => {
      mobileTween.reverse();
    }, { passive: true });
  }

  function showDesktopSearch() {
    // ignore click while tweening
    if (mainTl.totalProgress() > 0 && mainTl.totalProgress() < 1) {
      console.log('playing');
      return;
    }

    // reverse tween if already open
    if (searchOpen) {
      // reenable body scroll
      document.documentElement.classList.remove('noscroll');

      activeFocusTrap.elements = null;
      searchOpen = false;
      mainTl.reverse();
      return;
    }

    // reset dynamic tweens as values could change between clicks
    dynamicTl.clear();
    mainTl.remove(dynamicTl);

    // get start dimensions and postion
    const start = logo.getBoundingClientRect();
    const iconStart = searchIcon.getBoundingClientRect();

    // update styling
    document.body.classList.add('search-active');

    // get new dimensions and postion
    const end = logo.getBoundingClientRect();
    const iconEnd = searchFormIcon.getBoundingClientRect();

    // calculate difference between start end end position for logo
    const invertx = start.left - end.left;
    const inverty = start.top - end.top;

    // calculate difference between start end end position for search icon
    const iconInvertx = iconStart.left - iconEnd.left;
    const iconInverty = iconStart.top - iconEnd.top;

    console.log({ iconInvertx, iconInverty });

    // create dynamic tweens
    dynamicTl
      .fromTo(logo, {
        x: invertx,
        y: inverty,
      }, {
        duration: 0.325,
        x: 0,
        y: 0,
        ease: 'sine.inOut',
      })
      .fromTo(searchFormIcon, {
        opacity: 1,
        x: iconInvertx,
        y: iconInverty,
      }, {
        duration: 0.325,
        x: 0,
        y: 0,
        ease: 'sine.inOut',
        immediateRender: false,
      }, '<')
      .to(searchInput, {
        duration: 0.275,
        autoAlpha: 1,
        ease: 'sine.out',
      });

    // add dynamic timeline to start of last main timeline tween
    mainTl.add(dynamicTl, '<');

    // prevent body scroll
    document.documentElement.classList.add('noscroll');

    // wait for next frame to reduce possible stutter at tween start
    requestAnimationFrame(() => {
      // set focusable elements, preventing focus of outside elements (used in flying-focus.js)
      activeFocusTrap.elements = focusableElements();

      searchOpen = true;
      mainTl.play();
    });
  }

  showSearch.addEventListener('click', showDesktopSearch, { passive: true });

  // listener for global elements to open search
  addEventListenerAll($$('.open-search'), 'click', (e) => {
    e.preventDefault();

    if (MOBILMEDIA.matches) {
      if (mobileTween) {
        mobileTween.play();
      }
    } else {
      showDesktopSearch();
    }
  });
}
